import { render, staticRenderFns } from "./SelectDiseaseCode.vue?vue&type=template&id=33022f3e&scoped=true"
import script from "./SelectDiseaseCode.vue?vue&type=script&lang=js"
export * from "./SelectDiseaseCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33022f3e",
  null
  
)

export default component.exports